// Page names in the words the sidebar uses. The browser tab, history and
// bookmarks all read "Serviti AI Platform" before, so every open tab looked
// the same; headings also drifted from their menu labels.
export const PAGE_TITLES = {
  '/dashboard': 'Dashboard',
  '/analytics': 'Leads',
  '/analytics/impact': 'Business impact',
  '/conversations': 'Conversations',
  '/support': 'Support tickets',
  '/whatsapp-inbox': 'Customer inbox',
  '/agent-management': 'My agents',
  '/get-started': 'Set up your agent',
  '/rag/sources': 'Business knowledge',
  '/rag/upload': 'Upload documents',
  '/rag/web-scraper': 'Add your website',
  '/go-live-checklist': 'Launch checklist',
  '/lead-intelligence': 'Lead insights',
  '/support-insights': 'Support insights',
  '/missed-opportunities': 'Missed opportunities',
  '/users': 'Team members',
  '/notification-settings': 'Lead alerts',
  '/support-notifications': 'Support alerts',
  '/whatsapp-outbound': 'Channels',
  '/plan-usage': 'Plan & usage',
  '/license-info': 'Plan details',
  '/my-profile': 'Profile',
  '/billing': 'Billing & payments',
};

/** "Leads · Serviti AI" for /t/<id>/analytics, or the product name alone. */
export const documentTitleFor = (pathname) => {
  const suffix = String(pathname || '').replace(/^\/(?:t\/[^/]+|platform)/, '').replace(/\/$/, '') || '/dashboard';
  const exact = PAGE_TITLES[suffix];
  const nested = exact || Object.keys(PAGE_TITLES)
    .filter((path) => suffix.startsWith(`${path}/`))
    .sort((a, b) => b.length - a.length)
    .map((path) => PAGE_TITLES[path])[0];
  return nested ? `${nested} · Serviti AI` : 'Serviti AI';
};
